import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { EditQuestionAnswers } from '../../common';
import { doScrollToErrorMessage } from '~/utils';
import { appointmentActions } from '~/api';
import { questionsActions } from '~/components';

export class EditAppointmentQuestionAnswers extends PureComponent {
  onSaveDataHandler = (answers) => {
    const { dispatchUpdateAppointment } = this.props;

    return dispatchUpdateAppointment({ answers });
  };

  preloadData = () => {
    const {
      appointmentTypeId,
      useStaticQuestions,

      dispatchLoadAppointment,
      dispatchRetrieveQuestions,
      shopId,
    } = this.props;

    return Promise.all([
      dispatchLoadAppointment(shopId),
      dispatchRetrieveQuestions(appointmentTypeId, useStaticQuestions),
    ]);
  };

  componentDidUpdate(prevprevProps) {
    const { errorMessages } = this.props;
    const canScrollToErrorMessage = prevprevProps.errorMessages !== errorMessages;

    doScrollToErrorMessage(canScrollToErrorMessage); // Validate condition to scroll to error message
  }

  render() {
    return (
      <EditQuestionAnswers
        onSaveDataHandler={this.onSaveDataHandler}
        preloadData={this.preloadData}
        {...this.props}
      />
    );
  }
}

export const mapStateToProps = ({
  services: {
    config: { useStaticQuestions },
  },
  appointment: {
    draft: {
      appointmentType: { id: appointmentTypeId },
      shop: { id: shopId },
    },
  },
  messages: {
    app: { errorMessages },
  },
}) => ({
  useStaticQuestions,
  appointmentTypeId,
  shopId,
  errorMessages: errorMessages || [],
});

const mapDispatchToProps = {
  dispatchLoadAppointment: appointmentActions.loadAppointment,
  dispatchRetrieveQuestions: questionsActions.retrieveQuestions,
  dispatchUpdateAppointment: appointmentActions.updateAppointment,
};

export const ConnectedEditAppointmentQuestionAnswers = connect(
  mapStateToProps,
  mapDispatchToProps,
)(EditAppointmentQuestionAnswers);

EditAppointmentQuestionAnswers.propTypes = {
  useStaticQuestions: PropTypes.bool,
  appointmentTypeId: PropTypes.string.isRequired,
  shopId: PropTypes.string.isRequired,

  dispatchLoadAppointment: PropTypes.func.isRequired,
  dispatchRetrieveQuestions: PropTypes.func.isRequired,
  dispatchUpdateAppointment: PropTypes.func.isRequired,
  errorMessages: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

EditAppointmentQuestionAnswers.defaultProps = {
  useStaticQuestions: false,
};
